import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'antd';
import { UpTriangleV2 } from '../../../../../../assets/RpmAssets/SvgIcons'
import { allergentOptions, l3navoptions, category,settingsoption } from '../../../../Constants/Menus/ConstantMenus'
import Dropdown from '../../../DropDown/Dropdown'
import { Link, useLocation, useRouteMatch,useHistory } from 'react-router-dom'

import { vitalsettings,getvitalsettings } from '../../../../../../actions/RPMAction';
import './settingscomponent.css'

// import { ALLERGY_REDUX_STATE } from '../../../../Redux/Const'

function SettingsComponent() {

    const location = useLocation();  
  //  const patientId=location.state?.patientId;

    let dispatch = useDispatch();
    let [activeTop, setActiveTop] = useState(0)
    let [activeTabname, setActiveTabName] = useState("Pulse")

    //value taken
    let [basevalue, setBasevalue] = useState(0)
    let [abnormalvalue, setAbnormalvalue] = useState(0)
    let [criticalvalue, setCriticalvalue] = useState(0)

    let [basecategory, setBasecategory] = useState(0)
    let [abnormalcategory, setAbnormalcategory] = useState(0)
    let [criticalcategory, setCriticalcategory] = useState(0)

    let [baseaction, setActionbase] = useState(0)
    let [abnormalaction, setActionabnormal] = useState(0)
    let [criticalaction, setActioncritical] = useState(0)

    let gettabname =({name})=>
    {
        setActiveTabName(name)
        
        
        
    }
    const patientId=localStorage.getItem('patientId')
     useEffect(() => {
        dispatch(getvitalsettings(patientId));  
   },[])


    let savesettings = ()=>{
        let basevalues = basevalue;
        let abnormalvalues = abnormalvalue;
        let criticalvalues = criticalvalue;
        let categories =basecategory+"|"+abnormalcategory+"|"+criticalcategory

        console.log("basevalue"+basevalues)
        console.log("abnormalvalues"+abnormalvalues)
        console.log("criticalvalues"+criticalvalues)
        console.log("type"+activeTabname)
        console.log("type"+categories)
        dispatch(vitalsettings(patientId,basevalues,abnormalvalues,criticalvalues,activeTabname,basecategory)); 

        // vitalsettings(patientId,basevalues,abnormalvalues,criticalvalues,basecategory).then((res)=>{
        //   console.log(res)
        // })
 
        
    }
   

    return (
        <div className='settings-component-container'>

            <div className="l3-nav">
                <ul>
                    {
                        settingsoption.map((element, key) => {
                            return (
                                <>
                                    <li
                                        key={key}
                                        className={activeTop === key ? "l2-nav-active" : null}
                                        onClick={() => { setActiveTop(key);  gettabname(element);}}
                                        onChange={() => { gettabname(element) }}
                                    >{element.name}</li>{key < settingsoption.length - 1 ? " | " : null}
                                </>
                            )
                        })
                    }
                </ul>
            </div>


            {
                settingsoption[activeTop]?.component

            }

            

           



        </div>
    )
}

export default SettingsComponent